export default [
    {
        value: "Pessoas",
        text: "Pessoas",
        sub: false,
        permissao: { c: true, r: true, u: true, d: true },
        subEnums: [
            "PessoasEmpresas",
        ]
    },
    {
        value: "PessoasEmpresas",
        text: "Empresas relacionadas",
        sub: true,
        permissao: { c: false, r: true, u: true, d: false }
    },
    {
        value: "Equipe",
        text: "Equipe",
        sub: false,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "Usuarios",
        text: "Usuários",
        sub: false,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "UsuariosPermissoes",
        text: "Permissões",
        sub: true,
        permissao: { c: false, r: true, u: true, d: false },
        somenteAdmin: true
    },
    {
        value: "Empresas",
        text: "Empresas no sistema",
        sub: false,
        permissao: { c: true, r: true, u: true, d: true },
        CUDAdmin: true,
        somenteAdmin: true
    },
    {
        value: "AprovacaoUsuario",
        text: "Aprovação de usuários",
        sub: false,
        permissao: { c: false, r: true, u: true, d: true },
        CUDAdmin: true
    },
    {
        value: "Perfis",
        text: "Perfis",
        sub: false,
        permissao: { c: true, r: true, u: true, d: true },
        somenteAdmin: true
    },
    {
        value: "TermosPolitica",
        text: "Termos e politicas",
        sub: false,
        permissao: { c: false, r: true, u: true, d: false },
        somenteAdmin: true
    },
    {
        value: "BancoDemanda",
        text: "Banco de demandas",
        sub: false,
        permissao: { c: true, r: true, u: true, d: true },
        tipoUsuarioCUD: 'proponente'
    },
    {
        value: "Proposta",
        text: "Propostas",
        sub: false,
        permissao: { c: true, r: true, u: true, d: true },
        subEnums: [
            "PropostaDescricaoTecnica",
            "PropostaEmpresas",
            "PropostaRecursoHumano",
            "PropostaServicoTerceiro",
            "PropostaMaterialConsumo",
            "PropostaMaterialPermanente",
            "PropostaViagemDiarias",
            "PropostaOutros",
            "PropostaCronogramaEtapas",
            "PropostaEntregaveis",
            "PropostaCronogramaFinanceiro",
            "PropostaInvestimento",
        ]
    },
    {
        value: "PropostaDescricaoTecnica",
        text: "Descrição técnica",
        sub: true,
        permissao: { c: true, r: true, u: true, d: false }
    },
    {
        value: "PropostaEmpresas",
        text: "Empresas",
        sub: true,
        permissao: { c: false, r: true, u: true, d: true }
    },
    {
        value: "PropostaRecursoHumano",
        text: "RH - Recursos humanos",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "PropostaServicoTerceiro",
        text: "ST - Serviços terceiros",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "PropostaMaterialConsumo",
        text: "MC - Materiais de consumo",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "PropostaMaterialPermanente",
        text: "MPE - Materiais permanentes e equipamentos",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "PropostaViagemDiarias",
        text: "VD - Viagens e diárias",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "PropostaOutros",
        text: "OU - Outros",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "PropostaCronogramaEtapas",
        text: "Cronograma de etapas",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "PropostaEntregaveis",
        text: "Entregáveis",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "PropostaCronogramaFinanceiro",
        text: "Cronograma financeiro",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "PropostaInvestimento",
        text: "Distribuição por Rubricas",
        sub: true,
        permissao: { c: false, r: true, u: true, d: false }
    },
    {
        value: "PlanejamentoEstrategico",
        text: "Planejamento estratégico",
        sub: false,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPd",
        text: "Projetos P&D",
        sub: false,
        permissao: { c: true, r: true, u: true, d: true },
        subEnums: [
            "ProjetosPdObrigacoesAneel",
            "ProjetosPdEmpresas",
            "ProjetosPdRecursoHumano",
            "ProjetosPdServicoTerceiro",
            "ProjetosPdMaterialConsumo",
            "ProjetosPdMaterialPermanente",
            "ProjetosPdViagemDiaria",
            "ProjetosPdOutros",
            "ProjetosPdEntregaveis",
            "ProjetosPdCronogramaEtapa",
            "ProjetosPdCronogramaFinanceiro",
            "ProjetosPdContrato",
            "ProjetosPdCaracteristicaProjeto",
            "ProjetosPdCapacitacaoProfissional",
            "ProjetosPdProducaoCientifica",
            "ProjetosPdApoioInfraestrutura",
            "ProjetosPdPropriedadeIntelectual",
            "ProjetosPdImpactosSocioambientais",
            "ProjetosPdImpactosEconomicos",
            "ProjetosPdInvestimentos",
            "ProjetosPdTRL",
        ]
    },
    {
        value: "ProjetosPdObrigacoesAneel",
        text: "Obrigações na ANEEL",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPdEmpresas",
        text: "Empresas",
        sub: true,
        permissao: { c: false, r: true, u: true, d: false }
    },
    {
        value: "ProjetosPdRecursoHumano",
        text: "RH - Recursos humanos",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPdServicoTerceiro",
        text: "ST - Serviços de terceiros",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPdMaterialConsumo",
        text: "MC - Materiais de consumo",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPdMaterialPermanente",
        text: "MPE - Materiais permanentes e equipamentos",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPdViagemDiaria",
        text: "VD - Viagens e diárias",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPdOutros",
        text: "OU - Outros",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPdEntregaveis",
        text: "Entregáveis",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPdCronogramaEtapa",
        text: "Cronograma de etapas",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPdCronogramaFinanceiro",
        text: "Cronograma financeiro",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPdContrato",
        text: "Contratos",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPdCaracteristicaProjeto",
        text: "Características do projeto",
        sub: true,
        permissao: { c: false, r: true, u: true, d: false }
    },
    {
        value: "ProjetosPdCaracteristicaProjetoProdutoPrincipal",
        text: "Características do projeto - Produto principal",
        sub: true,
        permissao: { c: false, r: true, u: true, d: false },
        esconder: true
    },
    {
        value: "ProjetosPdCaracteristicaProjetoTecnicaEmpregada",
        text: "Características do projeto - Técnica empregada",
        sub: true,
        permissao: { c: false, r: true, u: true, d: false },
        esconder: true
    },
    {
        value: "ProjetosPdCaracteristicaProjetoAplicabilidadePrevista",
        text: "Características do projeto - Aplicabilidade prevista",
        sub: true,
        permissao: { c: false, r: true, u: true, d: false },
        esconder: true
    },
    {
        value: "ProjetosPdCaracteristicaProjetoTransferenciaTecnologica",
        text: "Características do projeto - Transferência técnológica",
        sub: true,
        permissao: { c: false, r: true, u: true, d: false },
        esconder: true
    },
    {
        value: "ProjetosPdCapacitacaoProfissional",
        text: "Capacitação profissional",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPdProducaoCientifica",
        text: "Produção científica",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPdApoioInfraestrutura",
        text: "Apoio à infraestrutura",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPdPropriedadeIntelectual",
        text: "Propriedade intelectual",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPdImpactosSocioambientais",
        text: "Impactos socioambientais",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPdImpactosEconomicos",
        text: "Impactos econômicos",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosPdInvestimentos",
        text: "Distribuição por Rubricas",
        sub: true,
        permissao: { c: false, r: true, u: true, d: false }
    },
    {
        value: "ProjetosPdTRL",
        text: "TRL - Grau de maturidade tecnológica",
        sub: true,
        permissao: { c: false, r: true, u: true, d: false }
    },
    {
        value: "ProjetosGestao",
        text: "Projetos de gestão",
        sub: false,
        permissao: { c: true, r: true, u: true, d: true },
        subEnums: [
            "ProjetosGestaoDetalhes",
            "ProjetosGPPDIDetalhes",
            "ProjetosGestaoEmpresas",
            "ProjetosGestaoRecursoHumano",
            "ProjetosGestaoServicoTerceiro",
            "ProjetosGestaoMaterialConsumo",
            "ProjetosGestaoViagemDiarias",
            "ProjetosGestaoOutros",
            "ProjetosGestaoCitenel",
            "ProjetosGestaoAuditoria",
            "ProjetosGestaoAtividades",
            "ProjetosGestaoCronogramaEtapa",
            "ProjetosGestaoInvestimento",
            "ProjetosGestaoObrigacoesAneel",
            "ProjetosGestaoContrato",
            "ProjetosGestaoCapacitacaoProfissional",
            "ProjetosGestaoProducaoCientifica",
        ]
    },
    {
        value: "ProjetosGestaoDetalhes",
        text: "Detalhes",
        sub: true,
        permissao: { c: true, r: true, u: true, d: false }
    },
    {
        value: "ProjetosGPPDIDetalhes",
        text: "Detalhes",
        sub: true,
        permissao: { c: true, r: true, u: true, d: false }
    },
    {
        value: "ProjetosGestaoEmpresas",
        text: "Empresas",
        sub: true,
        permissao: { c: false, r: true, u: true, d: false }
    },
    {
        value: "ProjetosGestaoRecursoHumano",
        text: "RH - Recursos humanos",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosGestaoServicoTerceiro",
        text: "ST - Serviços de terceiros",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosGestaoMaterialConsumo",
        text: "MC - Materiais de consumo",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosGestaoViagemDiarias",
        text: "VD - Viagens e diárias",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosGestaoOutros",
        text: "OU - Outros",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosGestaoCitenel",
        text: "CT - Citenel",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosGestaoAuditoria",
        text: "AC - Auditoria contábil",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosGestaoAtividades",
        text: "Atividades",
        sub: true,
        permissao: { c: false, r: true, u: true, d: false }
    },
    {
        value: "ProjetosGestaoCronogramaEtapa",
        text: "Cronograma de etapas",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosGestaoInvestimento",
        text: "Distribuição por Rubricas",
        sub: true,
        permissao: { c: false, r: true, u: true, d: false }
    },
    {
        value: "ProjetosGestaoObrigacoesAneel",
        text: "Obrigações na ANEEL",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosGestaoContrato",
        text: "Contrato e documentação",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosGestaoCapacitacaoProfissional",
        text: "Capacitação profissional",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosGestaoProducaoCientifica",
        text: "Produção científica",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosRn219",
        text: "Projetos encerrados RN 219 (Regra antiga)",
        sub: false,
        permissao: { c: true, r: true, u: true, d: true },
        subEnums: [
            "ProjetosRn219Desembolsos",
            "ProjetosRn219Custos",
        ]
    },
    {
        value: "ProjetosRn219Desembolsos",
        text: "Desembolsos",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosRn219Custos",
        text: "Custos",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosRn316",
        text: "Projetos encerrados RN 316 (Regra nova)",
        sub: false,
        permissao: { c: true, r: true, u: true, d: true },
        subEnums: [
            "ProjetosRn316Desembolsos",
            "ProjetosRn316Custos",
        ]
    },
    {
        value: "ProjetosRn316Desembolsos",
        text: "Desembolsos",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ProjetosRn316Custos",
        text: "Custos",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "Fndct",
        text: "FNDCT",
        sub: false,
        permissao: { c: true, r: true, u: false, d: true }
    },
    {
        value: "Cde",
        text: "CDE",
        sub: false,
        permissao: { c: true, r: true, u: false, d: true }
    },
    {
        value: "Mme",
        text: "MME",
        sub: false,
        permissao: { c: true, r: true, u: false, d: true }
    },
    {
        value: "ModelosDocumentos",
        text: "Modelos de documentos",
        sub: false,
        permissao: { c: true, r: true, u: true, d: true },
        CUDAdmin: true
    },
    {
        value: "MovimentacaoFinanceira",
        text: "Movimentação financeira",
        sub: false,
        permissao: { c: false, r: true, u: true, d: false },
        subEnums: [
            "MovimentacaoFinanceiraRol",
            "MovimentacaoFinanceiraSelic",
            "MovimentacaoFinanceiraAnexo2",
            "MovimentacaoFinanceiraAnexo61",
            "MovimentacaoFinanceiraAnexo62",
            "MovimentacaoFinanceiraGrafico",
        ]
    },
    {
        value: "MovimentacaoFinanceiraRol",
        text: "ROL",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "MovimentacaoFinanceiraSelic",
        text: "SELIC",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "MovimentacaoFinanceiraAnexo2",
        text: "Anexo 2",
        sub: true,
        permissao: { c: false, r: true, u: true, d: false }
    },
    {
        value: "MovimentacaoFinanceiraAnexo2ProjetosEncerrados",
        text: "Anexo 2 - Projetos encerrados",
        sub: true,
        permissao: { c: true, r: true, u: true, d: true },
        esconder: true
    },
    {
        value: "MovimentacaoFinanceiraAnexo61",
        text: "Anexo 6.1",
        sub: true,
        permissao: { c: true, r: true, u: true, d: false }
    },
    {
        value: "MovimentacaoFinanceiraAnexo61Baixas",
        text: "Anexo 6.1 - Baixas",
        sub: true,
        permissao: { c: true, r: true, u: true, d: false },
        esconder: true
    },
    {
        value: "MovimentacaoFinanceiraAnexo62",
        text: "Anexo 6.2",
        sub: true,
        permissao: { c: false, r: true, u: true, d: false }
    },
    {
        value: "MovimentacaoFinanceiraGrafico",
        text: "Gráfico",
        sub: true,
        permissao: { c: false, r: true, u: false, d: false }
    },
    {
        value: "ProjecaoFinanceira",
        text: "Projeção financeira",
        sub: false,
        permissao: { c: true, r: true, u: true, d: true }
    },
    {
        value: "ContratoLicenca",
        text: "Contratos de Licença",
        sub: false,
        permissao: { c: true, r: true, u: true, d: true }
    },
]